import zIndex from "@mui/material/styles/zIndex";
import Select from "react-select";

function CustomerHistorySelect(props) {
  const customOption = props?.optionList.map((item) => {
    return { ...item, label: `${item.Transaction_Type_Name}` };
  });

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 34,
      backgroundColor: "#FFFFFF",
      width: 200,
    }),
  
    valueContainer: (styles) => ({
      ...styles,
      height: 34,
      padding: "0 8px",
    }),
  
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // VERY IMPORTANT
    }),
  
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isFocused ? "#E6E6E6" : "#F1F1F1",
      color: "black",
    }),
  };
  

  const handleChange = (value) => {
    props.onTypeSelect(value);
  };

  return (
    <>
      <Select
        styles={customStyles}
        //   defaultValue={props?.defaultVal}
        placeholder="Select Type"
        onChange={handleChange}
        options={customOption}
        className=""
      />
    </>
  );
}

export default CustomerHistorySelect;
